import React from 'react';
import { Link } from 'react-router-dom';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { ListProposals } from './ListProposals';

export const ModalProposals = ({
  isOpen,
  toggle,
  customerName,
  proposalsAssociates,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      zIndex={10000}
      backdrop={'static'}
      id="staticBackdrop"
      size="xl"
      centered
    >
      <ModalHeader>
        <p>Propostas de {customerName}</p>
      </ModalHeader>
      <ModalBody>
        <ListProposals proposalsAssociates={proposalsAssociates} />
      </ModalBody>
      <ModalFooter>
        <Link to="#" className="btn btn-primary mt-3" onClick={() => toggle()}>
          Fechar
        </Link>
      </ModalFooter>
    </Modal>
  );
};
